$(document).on('ready', function() {
    $('.carousel').slick({
    dots: true,
    infinite: true,
    arrows: false,
    speed: 500,
	autoplaySpeed: 5000,
    autoplay: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
        slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
        slidesToShow: 1
        }
      }
    ]
  });
     $('.collection-slide').slick({
       
    dots: false,
    infinite: true,
    arrows: true,
    speed: 500,
    slidesToShow: 4,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          centerMode: true,
        arrows: false,
        slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          centerMode: true,
        arrows: false,
        slidesToShow: 1
        }
      }
    ]
  });
   $('.instagram-slide').slick({
    dots: false,
    infinite: false,
    arrows: true,
    speed: 500,
    slidesToShow: 4,
    responsive: [
      {
        breakpoint: 769,
        settings: {
        slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
        slidesToShow: 2
        }
      }
    ] 
  });
  $('.trust-slide').slick({
    dots: false,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 6,
    responsive: [
      {
        breakpoint: 768,
        settings: {
        slidesToShow: 3
        }
      }
    ]
  });
  $('.review-slide').slick({
    dots: false,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 768,
        settings: {
         arrows: true,
        slidesToShow: 1
        }
      }
    ]
  });
  $('.blog-slide').slick({
    dots: false,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          infinite: false,
          slidesToShow: 1
//           adaptiveHeight: true
        }
      }
    ]
  });
  $('.pro-carousel-thum').slick({
    dots: false,
    infinite: false,
    arrows: false,
    slidesToShow: 5,
    vertical:true,
    verticalSwiping:true,
    slidesToScroll: 1,
    focusOnSelect: true,
  });
  $('.pro-carousel-thum .slick-slide').click(function() {
    var thum_val = $(this).attr('data-slick-index');
    $(".slide-thum-show .site-box-content").flickity( 'select', thum_val );
  });
 
 var n = $( ".carousel .slick-dots li" ).size();
  $('.carousel .slick-dots').append('<li class="progress-bar"><span class="current_slide">0'+ 1 + '</span> <span class="progress_line"></span> 0' + n +'</li>');
  $('div[class^="carousel-slide--"]').on('click',function(){
    $('.carousel .slick-dots li').each(function(){
      if ($(this).hasClass('slick-active')){
        var button_val = $(this).find('button').text();
        $('.carousel .slick-dots .progress-bar').find('.current_slide').html('0'+ button_val);
      };
    });
  });
  $('.carousel .slick-dots li').on('click', function(){
    if ($(this).hasClass('slick-active')){
    	var button_val = $(this).find('button').text();
		$('.carousel .slick-dots .progress-bar').find('.current_slide').html('0'+ button_val);
    };
  });
 
  $('.carousel').on('afterChange', function(event, slick, currentSlide, nextSlide){
    var button_val = parseInt(currentSlide) + parseInt(1);
    $('.carousel .slick-dots .progress-bar').find('.current_slide').html('0'+ button_val);
  });
  	
  

});


$('[add-to-cart]').on('click', function (e){
  e.preventDefault();
  const $form = $(this).closest('form').serialize();
  const $addtocart = $('[add-to-cart]').text();
  let $this = $(this);
  $.ajax({
    url: "/cart/add",
    data: $form,
    dataType: "json",
    beforeSend: function(){
      $this.find('.add-to-cart-text').html('<span class="preloader""><span>.</span><span>.</span><span>.</span></span>');
    },
    success: function(response){
      $('#site-nav--mobile').addClass('show-cart active');
      $('#site-overlay').addClass('active');
      $('body').addClass('sidebar-move');
      $.ajax({
        url: "/",
        dataType: "html",
        success: function(response){
          $('#site-cart').html($(response).find('#site-cart').html());
          $this.html('<span class="add-to-cart-text">' + window.product_words_add_to_cart_button +'</span>');
        },
        error: function(){

        }
      });
    },
    error: function(){
    
    }
  });
});

//Gtranslate modification, set special language to zendesk Help box.
var gt_lang = document.querySelector("html").lang || "en";
if(gt_lang != "en") {
  setTimeout(function(){
    if(typeof zE === "function")
    	zE('webWidget', 'setLocale', gt_lang);
  }, 8000);
}

// $('.banner-hero-image').slick({
//   dots: true,
//   infinite: true,
//   speed: 300,
//   slidesToShow: 1,
//   adaptiveHeight: true
// });
		